<template>
    <div class="ui-tooltip">
        <slot />
        <div v-if="content" class="ui-tooltip__content" :class="`ui-tooltip__content--${placement}`">
            {{ content }}
        </div>
    </div>
</template>

<script>
export default {
    name: "TooltipComponent",
    props: {
        content: {
            type: String,
            default: "",
        },
        placement: {
            type: String,
            default: "top",
        },
    },
};
</script>

<style scoped lang="scss">
.ui-tooltip {
    position: relative;
    display: inline-flex;
    align-items: center;
    min-width: 0;
    max-width: 100%;
}

.ui-tooltip__content {
    position: absolute;
    left: 50%;
    z-index: 30;
    min-width: max-content;
    max-width: 360px;
    padding: 8px 10px;
    border-radius: 8px;
    background: rgba(17, 24, 39, 0.94);
    color: #ffffff;
    font-size: 12px;
    line-height: 1.4;
    white-space: normal;
    word-break: break-word;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.18);
    opacity: 0;
    pointer-events: none;
    transform: translateX(-50%) translateY(6px);
    transition:
        opacity 0.16s ease,
        transform 0.16s ease;
}

.ui-tooltip__content--top {
    bottom: calc(100% + 10px);
}

.ui-tooltip__content--bottom {
    top: calc(100% + 10px);
}

.ui-tooltip:hover .ui-tooltip__content {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
}
</style>
